module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modules"
  }, [(_vm.modules.length) ? _vm._l((_vm.modules), function(item, index) {
    return _c('ModuleLayout', {
      key: index,
      attrs: {
        "item": item
      }
    })
  }) : _c('h3', {
    staticClass: "modules__title"
  }, [_vm._v("В данной программе модулей нет!")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c538acf","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/tabs/modules/Modules.vue
// module id = 00f76f098458ef6b30cf
// module chunks = 5